//#region import
import React, { useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import SubjectIcon from "@mui/icons-material/Subject";
import { Circle } from '@mui/icons-material';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
//#endregion

const RoleList = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [isOpenPermission, setisOpenPermission] = useState<boolean>(false);
    const [lstPermission, setLstPermission] = useState([]);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "nNo",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            minwidth: 90,
            width: 90,
        },
        {
            field: "sRoleName",
            headerName: "ประเภทผู้มีสิทธิ์ใช้งานระบบ",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            flex: 2,
            width: 220,
        },
        {
            field: "nTotalMenu",
            headerName: "สิทธิ์การใช้งาน",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 150,
            flex: 1,
            renderCell: (item) => {
                if (item.row.nTotalMenu > 0) {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nTotalMenu}</Typography>
                            <SubjectIcon
                                sx={{
                                    color: "#930012 !important",
                                    "&:hover": {
                                        color: "black !important",
                                    },
                                    cursor: "pointer",

                                }}
                                onClick={() => onOpenModal(item.row.sID)}
                            />
                        </>
                    );
                } else {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nTotalMenu}</Typography>
                            <SubjectIcon
                                sx={{
                                    color: "#d7d7d7 !important",
                                    "&:hover": {
                                        color: "#d7d7d7 !important",
                                    },
                                    cursor: "pointer",
                                }}

                            />
                        </>
                    );
                }
            },
        },
        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },

    ];

    const getTableRole = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };

        AxiosFn.Post(`Role/GetTableRole`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataRole],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };


    useEffect(() => {
        getTableRole(dataRow);

    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/RoleForm?sID=${encodeURI(sID)}`);
    };

    const onOpenModal = (e) => {
        setisOpenPermission(true);
        AxiosFn.Post(
            `Role/GetDataPermission`,
            { sRoleID: e },
            (res) => {
                setLstPermission(res.lstPermissionDeteil || []);
            },
            (err) => {
                if (!err.response) {
                    DialogFn.Warning(err.Message);
                }
            }
        );
    };

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อประเภทผู้มีสิทธิ์ใช้งานระบบ", sFieldName: "sRoleName", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },

    ];
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableRole}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    isShowCheckBox={false}
                    filterField={filter}
                />
            </Grid>

            <DialogPreview
                IsOpen={isOpenPermission}
                IsBackdropClick={false}
                onClose={() => { setisOpenPermission(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={'เมนู / ฟังก์ชัน'}

            >
                <Grid container justifyContent={"center"} >
                    {lstPermission.map((m) => (
                        <>
                            <Grid item container xs={12} md={12} spacing={1} sx={{ mt: "5px", marginLeft: 3 }}>
                                <Grid item container md={8} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: m.nfontWeight ? m.nfontWeight : 400 }}> {m.nLevel == 2 && <Circle sx={{ color: "#212836", height: "7px", marginLeft: 2 }} />}{m.sMenuName} </Typography></Grid >
                                <Grid item container md={4} >
                                    <Typography style={{ color: "White", fontSize: "15px", fontWeight: 400 }}>
                                        <Box component="span" sx={{ p: "3px", borderRadius: 1, width: "100%", height: 5, backgroundColor: m.sColor, }}>
                                            &nbsp; {m.sPermissionName} &nbsp;
                                        </Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </>
                    ))}

                </Grid>
            </DialogPreview >
            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default RoleList;

export const enum EnumStatus {
    isActive = 0,
    Active = 1,
}
